import './list.scss';
import React from 'react';
import { formatDepartmentName, onAllowPermissionSwitch } from '../../utils';
import rightIcon from '../../images/icon-right.png';
import { lang } from '@umu/ukit-lang';
import { classSet } from '@umu/umu-dom';
import { Tooltip } from '@umu/umu-design';
import { IListItem, RoleType, SectionType, TravelType } from '../../type';
import { If, PreImg } from 'common/src/components';
import UserAvatar from '../../../user/userAvatar/userAvatar';

const iconUnKnownCheck = require('../../images/icon-unknown-check.png');
const iconUnCheck = require('../../images/icon-un-check.png');
const iconCheck = require('../../images/icon-check.png');
interface IProps {
    role: any;
    itemData: IListItem;
    travelType: TravelType;
    sectionType: SectionType;
    index: number;
    selectedNum: number;
    isSearchMode: boolean;
    enterpriseName: string;
    limit?: number;
    onSelectedChange: (params: IListItem, isChecked: boolean) => void;
    onNextLevel: (params: IListItem) => void;
    onClickRemove: (params: IListItem) => void;
    onToggleName: (params: IListItem) => void;
    onClickFilter: (params: IListItem) => void;
}
export enum CHECKBOX_CHECK_TYPE {
    UN_CHECK,
    IS_CHECK,
    UNKNOWN_CHECK,
}
type ICheckboxMap = {
    [propName in CHECKBOX_CHECK_TYPE]: string;
};
interface ICheckboxProps {
    isChecked: CHECKBOX_CHECK_TYPE;
    disabledCheck?: boolean;
    onChange: (isCheck: boolean) => void;
}

const checkboxMap: ICheckboxMap = {
    [CHECKBOX_CHECK_TYPE.UN_CHECK]: iconUnCheck,
    [CHECKBOX_CHECK_TYPE.IS_CHECK]: iconCheck,
    [CHECKBOX_CHECK_TYPE.UNKNOWN_CHECK]: iconUnKnownCheck,
};

/**
 * 临时方案展示勾选框
 */
export const Checkbox = (props: ICheckboxProps) => {
    const { isChecked, disabledCheck = false, onChange } = props;
    const onClick = () => {
        if (!disabledCheck) {
            onChange(!isChecked);
        }
    };
    return (
        <PreImg>
            <img
                onClick={onClick}
                className={classSet({
                    'icon-img-check': true,
                    'icon-img-check-unknown': isChecked === CHECKBOX_CHECK_TYPE.UNKNOWN_CHECK,
                    'icon-disabled-check': disabledCheck,
                })}
                src={checkboxMap[isChecked]}
            />
        </PreImg>
    );
};
export const ListItem = (props: IProps) => {
    const listChildren: any[] = [];
    const listItemData = props.itemData;
    const { selectedNum } = props;

    const normalizeMemberItemTooltipTitle = (item: IListItem) => {
        return (
            <>
                <p>
                    <span className="tooltip-label">
                        {lang('邮箱')}
                        {lang('：')}
                    </span>
                    <span className="tooltip-content">{item.oriData.user_info.email || lang('暂无数据')}</span>
                </p>
                <p>
                    <span className="tooltip-label">
                        {lang('手机')}
                        {lang('：')}
                    </span>
                    <span className="tooltip-content">{item.oriData.user_info.phone || lang('暂无数据')}</span>
                </p>
                <p>
                    <span className="tooltip-label">
                        {lang('用户名')}
                        {lang('：')}
                    </span>
                    <span className="tooltip-content">{item.oriData.user_info.login_name || lang('暂无数据')}</span>
                </p>
                <p>
                    <span className="tooltip-label">
                        {lang('所属部门')}
                        {lang('：')}
                    </span>
                    <span className="tooltip-content">
                        {item.user_department_path || item.oriData.user_department_path || lang('暂无数据')}
                    </span>
                </p>
            </>
        );
    };

    const ListItemDepartmentLeft = (params: IListItem) => {
        const isSelected = params.isSelected;
        const isDisabledCheck = onAllowPermissionSwitch(params.oriData);
        const isAllowClick = params.checkable && !isDisabledCheck;
        const sampleName: string = formatDepartmentName(
            props.enterpriseName,
            params.name,
            params.id,
            params.oriData && params.oriData.parent_path,
        );

        const renderDepartmentMember = () => {
            const count = params.oriData ? params.oriData.member_count : 0;
            return (
                <span className="content-count">
                    {lang('（')}
                    {count}
                    {lang('）')}
                </span>
            );
        };
        return (
            <li className="list-department-item list-item list-department-item-left" key={params.id}>
                <div className="content">
                    <div className="content-check">
                        <Checkbox
                            isChecked={isSelected ? CHECKBOX_CHECK_TYPE.IS_CHECK : CHECKBOX_CHECK_TYPE.UN_CHECK}
                            onChange={(isChecked) => props.onSelectedChange(params, isChecked)}
                            disabledCheck={
                                !isAllowClick || (!isSelected && !!props.limit && selectedNum >= props.limit)
                            }
                        />
                    </div>
                    <If condition={props.isSearchMode}>
                        <span className="content-name">
                            <span
                                className="content-name-name"
                                onClick={() => isAllowClick && props.onToggleName(params)}
                            >
                                {sampleName}
                            </span>
                            <span className="content-name-count">{renderDepartmentMember()}</span>
                        </span>
                    </If>
                    <If condition={!props.isSearchMode}>
                        <span className="content-name">
                            <span
                                className="content-name-name"
                                onClick={() => isAllowClick && props.onToggleName(params)}
                            >
                                {params.name}
                            </span>
                            <If condition={!params.oriData || !params?.oriData.is_hidden_member_count}>
                                <span className="content-name-count">{renderDepartmentMember()}</span>
                            </If>
                        </span>
                    </If>

                    <div className="close">
                        <If condition={(!props.isSearchMode && params.isHaveNextLevel) || false}>
                            <PreImg>
                                <img src={rightIcon} alt="" onClick={() => props.onNextLevel(params)} className={params.isDisabledNextLevel ? "disabled-next-level" : ''}/>
                            </PreImg>
                        </If>
                    </div>
                </div>
            </li>
        );
    };

    const ListItemDepartmentRight = (params: IListItem) => {
        const sampleName: string = formatDepartmentName(
            props.enterpriseName,
            params.name,
            params.id,
            params.oriData && params.oriData.parent_path,
        );

        return (
            <li className="list-department-item list-item list-department-item-right" key={params.id}>
                <div className="content">
                    <span className="content-name">{sampleName}</span>
                    <span className="list-right-remove" onClick={() => props.onClickRemove(params)}>
                        {lang('移除')}
                    </span>
                </div>
            </li>
        );
    };

    const ListItemOwnerLeft = (params: IListItem) => {
        const isSelected = params.isSelected;
        const userAvatar = (
            <div className="avatar" onClick={() => params.checkable && props.onToggleName(params)}>
                <UserAvatar src={params.avatar || ''} className="data-user-avatar" width={24} />
            </div>
        );

        return (
            <li className="list-item list-item-owner list-item-owner-left" key={params.id}>
                <div className="content">
                    <div className="content-check">
                        <Checkbox
                            isChecked={isSelected ? CHECKBOX_CHECK_TYPE.IS_CHECK : CHECKBOX_CHECK_TYPE.UN_CHECK}
                            onChange={(isChecked) => props.onSelectedChange(params, isChecked)}
                            disabledCheck={false}
                        />
                    </div>
                    {userAvatar}
                    <span className="content-name">
                        <Tooltip
                            overlayClassName="task-assign-department-tooltip"
                            placement="right"
                            color="#fff"
                            title={normalizeMemberItemTooltipTitle(params)}
                        >
                            <span onClick={() => params.checkable && props.onToggleName(params)}>{params.name}</span>
                        </Tooltip>
                        {Number(params.oriData.role) === RoleType.admin ? (
                            <span className="member-principal">{lang('负责人')}</span>
                        ) : null}
                    </span>
                </div>
            </li>
        );
    };

    const ListItemOwnerRight = (params: IListItem) => {
        const userAvatar = (
            <div className="avatar">
                <UserAvatar src={params.avatar || ''} className="data-user-avatar" width={24} />
            </div>
        );

        return (
            <li className="list-item-owner list-item list-item-owner-right" key={params.id}>
                <div className="content">
                    {userAvatar}
                    <span className="content-name">
                        <Tooltip
                            color="#fff"
                            overlayClassName="task-assign-department-tooltip"
                            placement="right"
                            title={normalizeMemberItemTooltipTitle(params)}
                        >
                            {params.name}
                        </Tooltip>
                    </span>
                    <span className="list-right-remove" onClick={() => props.onClickRemove(params)}>
                        {lang('移除')}
                    </span>
                </div>
            </li>
        );
    };

    if (props.travelType === TravelType.department && props.sectionType === SectionType.left) {
        listChildren.push(ListItemDepartmentLeft(listItemData));
    } else if (props.travelType === TravelType.department && props.sectionType === SectionType.right) {
        listChildren.push(ListItemDepartmentRight(listItemData));
    } else if (props.travelType === TravelType.owner && props.sectionType === SectionType.left) {
        listChildren.push(ListItemOwnerLeft(listItemData));
    } else if (props.travelType === TravelType.owner && props.sectionType === SectionType.right) {
        listChildren.push(ListItemOwnerRight(listItemData));
    }

    return (
        <ul className="list-ul" key={props.itemData.id}>
            {listChildren}
        </ul>
    );
};
